export const affiliation = ["Corporate", "Clinical Trial"];